export default "__VITE_ASSET__CXJ0AIR2__"